/**
 * Returns the cookie `Secure` attribute suffix (`'; Secure'`) when the current
 * document is running in a secure context, or an empty string otherwise.
 *
 * The `Secure` attribute prevents the browser from ever transmitting the cookie
 * over an unencrypted `http://` connection, which mitigates cleartext token
 * capture (CWE-614). It is intentionally omitted on insecure/localhost dev,
 * because browsers reject `Secure` cookies set over `http://` and that would
 * silently break local testing.
 *
 * Used when building the Dynamic auth JWT cookie string so the attribute is
 * applied consistently on both the write (sign-in/refresh) and clear (logout)
 * paths.
 *
 * @notInstrumented
 */
export const getSecureCookieAttribute = (): string => {
  const isSecure =
    Boolean(globalThis.window?.isSecureContext) ||
    globalThis.location?.protocol === 'https:';

  return isSecure ? '; Secure' : '';
};
